// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2oaWS","box":"WorkspacesBox_box__1deZd","node":"WorkspacesBox_node__RfTKf"};